import { Component, Input, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { Filter } from 'app/shared/components/table/filter';
import { CommonService } from 'app/shared/services/common.service';
import { CouponService } from 'app/core/services/coupon.service';

@Component({
  selector: 'app-atn-export-excel',
  templateUrl: './atn-export-excel.component.html',
  styleUrls: ['./atn-export-excel.component.css']
})
export class AtnExportExcelComponent implements OnInit {
  [x: string]: any;
  @Input() request: any;
  @Input() table: any;
  @Input() fileName = 'data';
  newTable: [{}] = [{}]
  constructor(private localizationService: LocalizationService, private appAuthService: AppAuthService,
    private commonService: CommonService,private couponService:CouponService) {
  }

  ngOnInit(): void {
    console.log(this.request)
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }
  onExport() {
    if (this.fileName === 'customers') {
      this.exportCustomersToExcel();
    } else if (this.fileName === 'BusinessCoupon') {
      this.exportBusinessCouponToExcel();
    }
    
  }
    exportCustomersToExcel() {
     this.commonService.exportCustomersToExcel(this.businessId,
      this.request.Filter,
      this.request.Filter.Paging,
      )
      .subscribe(blob => {
        this.saveAsExcelFile(blob, 'lids');
      }, (err) => {
        console.log(err);
      })
  }
  exportBusinessCouponToExcel()
  {
    this.couponService.exportBusinessCouponToExcel(this.businessId,  this.request.Filter,
      this.request.Filter.Paging,)
      .subscribe(blob => {
        this.saveAsExcelFile(blob, 'BusinessCoupons');
      }, (err) => {
        console.log(err);
      })
  }
}


